/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTSVG} from '../../../helpers'
import {Dropdown1} from '../../content/dropdown/Dropdown1'
import {useGetUserPopularity} from "../../../api/hooks";
import {IFormValue} from "../../../../app/pages/dashboard/DashboardWrapper";

type Props = {
  className: string;
  formValue: IFormValue;
}

const ListsWidget6: React.FC<Props> = ({className, formValue}) => {
  const {data} = useGetUserPopularity({from:formValue.fromDate, to:formValue.toDate})
  const nullChecker = (data?:string) => {
    if(!!data){
      return data
    } else return '---'
  }
  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className={`h-50`}>
        <h3 className='fw-bold text-gray-800 bg-light-success w-100 h-50px p-4 rounded-top'>Content And Usage Popularity</h3>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='p-3'>
        {/* begin::Item */}
        <div className='d-flex align-items-center bg-light-warning rounded p-5 mb-5'>
          {/* begin::Icon */}
          <span className='svg-icon svg-icon-warning me-5'>
            <KTSVG path='/media/icons/duotune/abstract/abs027.svg' className='svg-icon-1' />
          </span>
          {/* end::Icon */}
          {/* begin::Title */}
          <div className='flex-grow-1 me-2'>
            <p className='fw-bold text-gray-800 text-hover-primary fs-6'>
              Most Popular Activity Type
            </p>
            <span className='text-muted fw-semibold d-block'>type: {nullChecker(data?.most_popular_activity_type?.type)}</span>
          </div>
          {/* end::Title */}
          {/* begin::Lable */}
          <span className='fw-bold text-warning py-1'>{data?.most_popular_activity_type?.activity_count}</span>
          {/* end::Lable */}
        </div>
        {/* end::Item */}
        {/* begin::Item */}
        <div className='d-flex align-items-center bg-light-warning rounded p-5 mb-5'>
          {/* begin::Icon */}
          <span className='svg-icon svg-icon-warning me-5'>
            <KTSVG path='/media/icons/duotune/abstract/abs027.svg' className='svg-icon-1' />
          </span>
          {/* end::Icon */}
          {/* begin::Title */}
          <div className='flex-grow-1 me-2'>
            <p className='fw-bold text-gray-800 text-hover-primary fs-6'>
              Least Popular Activity Type
            </p>
            <span className='text-muted fw-semibold d-block'>type: {nullChecker(data?.least_popular_activity_type?.type)}</span>
          </div>
          {/* end::Title */}
          {/* begin::Lable */}
          <span className='fw-bold text-warning py-1'>{data?.least_popular_activity_type?.activity_count}</span>
          {/* end::Lable */}
        </div>
        {/* end::Item */}
        {/* begin::Item */}
        <div className='d-flex align-items-center bg-light-success rounded p-5 mb-5'>
          {/* begin::Icon */}
          <span className='svg-icon svg-icon-success me-5'>
            <KTSVG path='/media/icons/duotune/abstract/abs027.svg' className='svg-icon-1' />
          </span>
          {/* end::Icon */}
          {/* begin::Title */}
          <div className='flex-grow-1 me-2'>
            <p className='fw-bold text-gray-800 text-hover-primary fs-6'>
              Popular Content By Activity Type
            </p>
            <span className='text-muted fw-semibold d-block'>type: {data?.popular_content_by_activity_type?.length ? nullChecker(data?.popular_content_by_activity_type[0]?.type) : '---'}</span>
            <span className='text-muted fw-semibold d-block'>{data?.popular_content_by_activity_type?.length ? data?.popular_content_by_activity_type[0]?.content?.entity?.title : '---'}</span>
          </div>
          {/* end::Title */}
          {/* begin::Lable */}
          <span className='fw-bold text-success py-1'>{data?.popular_content_by_activity_type?.length ? data?.popular_content_by_activity_type[0]?.content?.activity_count : '---'}</span>
          {/* end::Lable */}
        </div>
        {/* end::Item */}
        {/* begin::Item */}
        <div className='d-flex align-items-center bg-light-danger rounded p-5 mb-5'>
          {/* begin::Icon */}
          <span className='svg-icon svg-icon-danger me-5'>
            <KTSVG path='/media/icons/duotune/abstract/abs027.svg' className='svg-icon-1' />
          </span>
          {/* end::Icon */}
          {/* begin::Title */}
          <div className='flex-grow-1'>
            <p className='fw-bold text-gray-800 text-hover-primary fs-6' style={{marginBottom: '0'}}>
              Most Popular Grade
            </p>
            {/*<span className='text-muted fw-semibold d-block'>Due in 5 Days</span>*/}
          </div>
          {/* end::Title */}
          {/* begin::Lable */}
          <span className='fw-bold text-danger py-1'>{data?.most_popular_grade?.grade?.title}</span>
          {/* end::Lable */}
        </div>
        {/* end::Item */}
        {/* begin::Item */}
        <div className='d-flex align-items-center bg-light-info rounded p-5'>
          {/* begin::Icon */}
          <span className='svg-icon svg-icon-info me-5'>
            <KTSVG path='/media/icons/duotune/abstract/abs027.svg' className='svg-icon-1' />
          </span>
          {/* end::Icon */}
          {/* begin::Title */}
          <div className='flex-grow-1 me-2'>
            <a href='#' className='fw-bold text-gray-800 text-hover-primary fs-6'>
              Most Popular Subject
            </a>
            <span className='text-muted fw-semibold d-block'>subject: {data?.most_popular_subject?.length ? nullChecker(data?.most_popular_subject[0]?.data?.subject?.title) : '---'}</span>
            <span className='text-muted fw-semibold d-block'>content type: {data?.most_popular_subject?.length ? data?.most_popular_subject[0]?.event_type : '---'}</span>
          </div>
          {/* end::Title */}
          {/* begin::Lable */}
          {/*<span className='fw-bold text-info py-1'>+8%</span>*/}
          {/* end::Lable */}
        </div>
        {/* end::Item */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export {ListsWidget6}
